import { useRef } from 'react';
import { Box } from '@chakra-ui/react';
import NavBar from './NavBar';
import Hero from './Hero';
import About from './About';
import PracticeAreas from './PracticeAreas';
import Team from './Team';
import Testimonials from './Testimonials';
import Locations from './Locations';
import Contact from './Contact';
import Footer from './Footer';
import WhatsAppButton from './WhatsappButton';

const LandingPage: React.FC = () => {
  const sectionsRef = {
    home: useRef<HTMLDivElement>(null),
    about: useRef<HTMLDivElement>(null),
    'practice-areas': useRef<HTMLDivElement>(null),
    team: useRef<HTMLDivElement>(null),
    testimonials: useRef<HTMLDivElement>(null),
    locations: useRef<HTMLDivElement>(null),
    contact: useRef<HTMLDivElement>(null),
  };

  const scrollToSection = (section: string) => {
    const ref = sectionsRef[section as keyof typeof sectionsRef];
    if (ref?.current) {
      const yOffset = -80; // Offset for fixed navbar
      const y = ref.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <Box>
      <NavBar onNavigate={scrollToSection} />
      
      <Box ref={sectionsRef.home}>
        <Hero onNavigateToContact={() => scrollToSection('contact')} />
      </Box>

      <Box ref={sectionsRef.about}>
        <About />
      </Box>

      <Box ref={sectionsRef['practice-areas']}>
        <PracticeAreas />
      </Box>

      <Box ref={sectionsRef.team}>
        <Team />
      </Box>

      <Box ref={sectionsRef.testimonials}>
        <Testimonials />
      </Box>

      <Box ref={sectionsRef.locations}>
        <Locations />
      </Box>

      <Box ref={sectionsRef.contact} bg="alabasterGrey">
        <Contact />
      </Box>
      
      <Box>
        <Footer />
      </Box>

      <WhatsAppButton />
    </Box>
  );
};

export default LandingPage;
